import { f7 } from 'framework7-react';

/**
 * 全画面プリローダーの参照カウント付きラッパー。
 *
 * f7.preloader は単一のオーバーレイなので、複数の非同期処理が並行して
 * show/hide を直接呼ぶと、最初に終わった処理の hide でオーバーレイが消えてしまい、
 * 残りが読み込み中でも「読み込み完了」に見える（画面が虫食いになる）。
 * 呼び出し数を数え、最後の1件が終わるまで hide しない。
 */
let activeCount = 0;

export const showPreloader = () => {
  activeCount += 1;
  if (activeCount === 1) {
    f7.preloader.show();
  }
};

export const hidePreloader = () => {
  activeCount -= 1;
  if (activeCount <= 0) {
    activeCount = 0;
    f7.preloader.hide();
  }
};

/** 画面遷移などでカウントが残った場合の保険 */
export const resetPreloader = () => {
  activeCount = 0;
  f7.preloader.hide();
};
